// Third party
import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import { reducers } from './reducers';

// Data
import { PERSIST_KEYS, STORE_SLICES } from '../../utils/enums';
// Types
import { IRootState } from './types';
import { DEFAULT_APPEARANCE } from '../../data';

const initialState: IRootState = {
  tokenDetails: {} as IRootState['tokenDetails'],
  authenticateUser: {
    user: {
      settings: {
        ui: DEFAULT_APPEARANCE,
      },
      name: '',
      phone: '',
    },
  } as IRootState['authenticateUser'],
  isLoading: false,
  errorMsg: null,
};

export const slice = createSlice({
  name: STORE_SLICES.AUTHENTICATE,
  initialState,
  reducers,
});

const authActions = slice.actions;

const authPersistConfig = {
  key: PERSIST_KEYS.AUTH,
  storage,
};

export {
  authActions,
};
export default persistReducer(authPersistConfig, slice.reducer);
